<template>
    <div>
        <h1 style="font-size: 24px; color: black;">官方账户</h1>
        <div style="margin-bottom: 10px;">
            <el-button  type="primary" @click="showDetails('创建账号')">新增</el-button>
        </div>
        <h1>
            <el-table border
                      :data="userList">
                <el-table-column  label="账号昵称" prop="nickName"  ></el-table-column>
                <el-table-column  label="称号" prop="title"  ></el-table-column>
                <el-table-column  label="头像" >
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.head" width="70px" height="70px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  label="发布贴子数"  prop="post"></el-table-column>
                <el-table-column  label="操作"  align="center">
                    <template slot-scope="scope">
                        <el-button  plain size="mini" type="primary" @click="showDetails('编辑账号',scope.row)">编辑</el-button>
                        <el-button  plain size="mini" type="primary" @click="deleteUser(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column  label="开关"   >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isOpen"
                                   :active-value="true"
                                   :inactive-value="false"
                                   active-text="开启"
                                   inactive-text="关闭"
                                   @change="update(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
                <el-form :model="userEditForm" label-width="150px">
                    <el-form-item label="账号名称:" >
                        <el-input  style="width: 300px" type="text" v-model="userEditForm.nickName"></el-input>
                    </el-form-item>
                    <el-form-item label="称号:" >
                        <el-input  style="width: 300px" type="text" v-model="userEditForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="头像:" >
                            <el-upload
                                    :headers="headers"
                                    class="avatar-uploader"
                                    :action="uploadURL"
                                    :show-file-list="false"
                                    :on-success="handleBISuccess"
                                    :before-upload="function (file) { return beforeAvatarUpload(file)}"
                                    @click="uploadIcon">
                                <img v-if="userEditForm.head" :src="VUE_APP_CDN_URL+userEditForm.head" class="avatar">
                                <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                            </el-upload>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirm">确 定</el-button>
                        <el-button type="info" @click="cancel">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </h1>
    </div>
</template>

<script>
    import {
        gameUpload,
        allOfficialUser,
        editOfficialUser,
        deleteOfficialUser
    }from "@/http/api";
    export default {
        name: "OfficialAccount",
        data(){
            return{
                headers:{},
                VUE_APP_BASE_URL:'',
                VUE_APP_CDN_URL:'',
                uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
                userList:[],
                dialogVisible: false,
                dialogTitle :'',
                userEditForm: {},
            }
        },
        methods:{
            showDetails(title, row) {
                this.userEditForm = {
                    "id" : 0,
                    "post" : 0,
                    "nickName" :'',
                    "head" : '',
                    "title" : '',
                    "isOpen":true,
                    "did":''
                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.userEditForm = {
                        "id" : row.id,
                        "post" : row.post,
                        "nickName" :row.nickName,
                        "head" : row.head,
                        "title" :row.title,
                        "isOpen" : row.isOpen,
                        "did": row.did
                    };
                }
            },
            confirm(){
                editOfficialUser(this.userEditForm).then(resp=> {
                        if (resp.data.status===0){
                            this.dialogVisible = false;
                            this.queryList();
                        }
                    })

            },
            deleteUser(row){
                if(row.post>0){
                    return this.$message.error('该账户暂时不能删除')
                }else {
                    deleteOfficialUser(row).then(resp=> {
                        if (resp.data.status===0){
                            this.queryList();
                        }
                    })
                }
            },
            cancel(){
                this.dialogVisible=false;
            },
            handleBISuccess(response){
                this.userEditForm.head=response.info;
            },
            uploadIcon(){
                let func = gameUpload;
                func().then().catch(function () {
                })
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            update(row){
                editOfficialUser(row).then(resp=> {
                    if (resp.data.status===0){
                        this.queryList();
                    }
                })
            },
            queryList(){
                allOfficialUser().then(resp => {
                    this.userList = resp.data.info;
                });
            },

        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token};
            this.queryList();
        },
        mounted() {
            this.VUE_APP_BASE_URL=process.env.VUE_APP_BASE_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>